import { motion, AnimatePresence } from 'motion/react';
import { X, ShoppingCart, Minus, Plus } from 'lucide-react';
import { useState } from 'react';
import svgPaths from '../imports/svg-r5vgy5prt0';

interface CoinPackagesModalProps {
  isOpen: boolean;
  onClose: () => void;
  onPurchasePackage?: () => void;
}

// Coin Icon for header (purple)
function HeaderCoinIcon() {
  return (
    <svg width="20" height="20" fill="none" viewBox="0 0 20 20">
      <circle
        cx="10"
        cy="10"
        r="8"
        fill="#E9D5FF"
        stroke="#8B5CF6"
        strokeWidth="1.5"
      />
      <circle cx="10" cy="10" r="5" fill="#8B5CF6" />
      <text
        x="10"
        y="13"
        textAnchor="middle"
        fill="white"
        fontSize="8"
        fontWeight="bold"
      >
        ₲
      </text>
    </svg>
  );
}

// Ilustração de moedas empilhadas - Pacote Boas-vindas e Padrão
function StackedCoinsIllustration() {
  return (
    <div
      style={{
        position: 'relative',
        flexShrink: 0,
        width: '64px',
        height: '64px',
      }}
    >
      <div
        style={{
          position: 'absolute',
          inset: '14.15% 6.41% 12.26% 6.8%',
        }}
      >
        {/* Back coin group */}
        <div
          style={{
            position: 'absolute',
            inset: '14.15% 54.28% 16.91% 6.8%',
          }}
        >
          <div style={{ position: 'absolute', inset: '-1.59% -2.81%' }}>
            <svg
              style={{ display: 'block', width: '100%', height: '100%' }}
              fill="none"
              preserveAspectRatio="none"
              viewBox="0 0 27 46"
            >
              <g>
                <path
                  d={svgPaths.p4f93300}
                  fill="#FFEA52"
                  stroke="black"
                  strokeMiterlimit="10"
                  strokeWidth="1.4"
                />
                <path
                  d={svgPaths.p1fe61600}
                  fill="#FFD600"
                  stroke="#D0AF00"
                  strokeLinejoin="round"
                  strokeWidth="1.4"
                />
                <path
                  d={svgPaths.p26515200}
                  stroke="black"
                  strokeMiterlimit="10"
                  strokeWidth="1.4"
                />
                <path
                  d={svgPaths.p1b488a40}
                  stroke="black"
                  strokeMiterlimit="10"
                  strokeWidth="1.4"
                />
                <path
                  d={svgPaths.p119fd700}
                  stroke="black"
                  strokeMiterlimit="10"
                  strokeWidth="1.4"
                />
                <path
                  d={svgPaths.p34cc0080}
                  stroke="black"
                  strokeMiterlimit="10"
                  strokeWidth="1.4"
                />
                <path
                  d={svgPaths.p7c5ef80}
                  stroke="black"
                  strokeMiterlimit="10"
                  strokeWidth="1.4"
                />
              </g>
            </svg>
          </div>
        </div>

        {/* Middle coins */}
        <div
          style={{
            position: 'absolute',
            inset: '34.75% 6.41% 17.18% 54.76%',
          }}
        >
          <div style={{ position: 'absolute', inset: '-2.28% -2.82%' }}>
            <svg
              style={{ display: 'block', width: '100%', height: '100%' }}
              fill="none"
              preserveAspectRatio="none"
              viewBox="0 0 27 33"
            >
              <g>
                <path
                  d={svgPaths.p3774a40}
                  fill="white"
                  stroke="black"
                  strokeMiterlimit="10"
                  strokeWidth="1.4"
                />
                <path
                  d={svgPaths.p3785ea00}
                  fill="white"
                  stroke="black"
                  strokeMiterlimit="10"
                  strokeWidth="1.4"
                />
                <path
                  d={svgPaths.p7252900}
                  fill="white"
                  stroke="black"
                  strokeMiterlimit="10"
                  strokeWidth="1.4"
                />
                <path
                  d={svgPaths.p1a16f980}
                  fill="#FFEA52"
                  stroke="black"
                  strokeMiterlimit="10"
                  strokeWidth="1.4"
                />
                <path
                  d={svgPaths.pd6b2000}
                  fill="#FFD600"
                  stroke="#D0AF00"
                  strokeLinejoin="round"
                  strokeWidth="1.4"
                />
              </g>
            </svg>
          </div>
        </div>

        {/* Front coin */}
        <div
          style={{
            position: 'absolute',
            display: 'flex',
            inset: '49.67% 31.58% 12.26% 29.96%',
            alignItems: 'center',
            justifyContent: 'center',
          }}
        >
          <div
            style={{
              flex: 'none',
              height: '24.359px',
              width: '24.611px',
              transform: 'rotate(180deg) scaleY(-1)',
            }}
          >
            <div
              style={{ position: 'relative', width: '100%', height: '100%' }}
            >
              <div
                style={{
                  position: 'absolute',
                  inset: '-0.5% -0.42% -0.59% -0.41%',
                }}
              >
                <svg
                  style={{ display: 'block', width: '100%', height: '100%' }}
                  fill="none"
                  preserveAspectRatio="none"
                  viewBox="0 0 25 25"
                >
                  <g>
                    <path
                      d={svgPaths.p2bf0c080}
                      fill="#FFEA52"
                      stroke="black"
                      strokeWidth="1.4"
                    />
                    <path
                      d={svgPaths.p679700}
                      fill="#FFD600"
                      stroke="#D0AF00"
                      strokeLinejoin="round"
                      strokeWidth="1.4"
                    />
                  </g>
                </svg>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

// Ilustração de 3 moedas - Pacote Básico
function ThreeCoinsIllustration() {
  return (
    <div
      style={{
        position: 'relative',
        flexShrink: 0,
        width: '64px',
        height: '64px',
      }}
    >
      <div style={{ position: 'absolute', inset: '6.74% 9.66% 6.74% 8.49%' }}>
        {/* Left coin */}
        <div
          style={{ position: 'absolute', inset: '6.74% 52.9% 50.52% 8.49%' }}
        >
          <div style={{ position: 'absolute', inset: '-2.56% -2.83%' }}>
            <svg
              style={{ display: 'block', width: '100%', height: '100%' }}
              fill="none"
              preserveAspectRatio="none"
              viewBox="0 0 27 29"
            >
              <g>
                <path
                  d={svgPaths.p2c8bdf00}
                  fill="#FFEA52"
                  stroke="black"
                  strokeMiterlimit="10"
                  strokeWidth="1.4"
                />
                <path
                  d={svgPaths.p12bd5e80}
                  stroke="black"
                  strokeMiterlimit="10"
                  strokeWidth="1.4"
                />
                <path
                  d={svgPaths.p3a2d3a80}
                  fill="#FFD600"
                  stroke="#D0AF00"
                  strokeLinejoin="round"
                  strokeWidth="1.4"
                />
              </g>
            </svg>
          </div>
        </div>

        {/* Right coin */}
        <div
          style={{ position: 'absolute', inset: '21.16% 9.66% 49.4% 60.94%' }}
        >
          <div style={{ position: 'absolute', inset: '-3.71% -3.72%' }}>
            <svg
              style={{ display: 'block', width: '100%', height: '100%' }}
              fill="none"
              preserveAspectRatio="none"
              viewBox="0 0 21 21"
            >
              <g>
                <path
                  d={svgPaths.p32268c00}
                  fill="#FFEA52"
                  stroke="black"
                  strokeMiterlimit="10"
                  strokeWidth="1.4"
                />
                <path
                  d={svgPaths.pb9bef00}
                  stroke="black"
                  strokeMiterlimit="10"
                  strokeWidth="1.4"
                />
                <path
                  d={svgPaths.pe8e7e00}
                  fill="#FFD600"
                  stroke="#D0AF00"
                  strokeLinejoin="round"
                  strokeWidth="1.4"
                />
              </g>
            </svg>
          </div>
        </div>

        {/* Center coin */}
        <div
          style={{
            position: 'absolute',
            left: '31.16%',
            right: '25.13%',
            top: '50%',
            bottom: '6.74%',
          }}
        >
          <svg
            style={{ display: 'block', width: '100%', height: '100%' }}
            fill="none"
            preserveAspectRatio="none"
            viewBox="0 0 28 28"
          >
            <g>
              <path
                d={svgPaths.p3674a80}
                fill="#FFEA52"
                stroke="black"
                strokeWidth="1.4"
              />
              <path
                d={svgPaths.p73b4c00}
                fill="#FFD600"
                stroke="#D0AF00"
                strokeLinejoin="round"
                strokeWidth="1.4"
              />
            </g>
          </svg>
        </div>
      </div>
    </div>
  );
}

// Ilustração premium com sacola
function PremiumCoinIllustration() {
  return (
    <div
      style={{
        position: 'relative',
        flexShrink: 0,
        width: '64px',
        height: '64px',
      }}
    >
      <svg width="64" height="64" fill="none" viewBox="0 0 64 64">
        {/* Bag */}
        <g transform="translate(12, 7)">
          <path
            d={svgPaths.pb4a5d00}
            fill="white"
            stroke="black"
            strokeMiterlimit="10"
            strokeWidth="1.4"
          />
          <path d={svgPaths.p27c31200} fill="#FFEA52" />
          <path
            d={svgPaths.pb4a5d00}
            stroke="black"
            strokeMiterlimit="10"
            strokeWidth="1.4"
          />
          <path
            d={svgPaths.p114f0380}
            fill="white"
            stroke="black"
            strokeMiterlimit="10"
            strokeWidth="1.4"
          />
        </g>
        {/* Coin stack */}
        <g transform="translate(26, 12)">
          <ellipse
            cx="12"
            cy="16"
            rx="10"
            ry="5"
            fill="#FFEA52"
            stroke="black"
            strokeWidth="1.2"
          />
          <ellipse
            cx="12"
            cy="14"
            rx="10"
            ry="5"
            fill="#FFD600"
            stroke="#D0AF00"
            strokeWidth="1.2"
          />
          <ellipse
            cx="12"
            cy="8"
            rx="10"
            ry="5"
            fill="#FFEA52"
            stroke="black"
            strokeWidth="1.2"
          />
          <ellipse
            cx="12"
            cy="6"
            rx="10"
            ry="5"
            fill="#FFD600"
            stroke="#D0AF00"
            strokeWidth="1.2"
          />
        </g>
      </svg>
    </div>
  );
}

interface PackageOption {
  id: string;
  name: string;
  coins: number;
  price: string;
  bonusCoins?: number;
  bonusPercentage?: string;
  type: 'welcome' | 'basic' | 'standard' | 'premium';
  borderColor?: string;
  titleColor?: string;
  pricePrefix?: string;
}

const packages: PackageOption[] = [
  {
    id: 'welcome',
    name: 'Pacote de boas-vindas! 🎉',
    coins: 1000,
    price: 'R$ 169,90',
    bonusCoins: 800,
    bonusPercentage: '+80%',
    type: 'welcome',
    borderColor: '#6b34bf',
    titleColor: '#6b34bf',
  },
  {
    id: 'basic',
    name: 'Pacote básico',
    coins: 1200,
    price: 'R$ 179,90',
    type: 'basic',
    titleColor: '#556476',
  },
  {
    id: 'standard',
    name: 'Pacote padrão',
    coins: 2400,
    price: 'R$ 358,90',
    bonusCoins: 120,
    bonusPercentage: '+5%',
    type: 'standard',
    titleColor: '#005bdb',
  },
  {
    id: 'premium',
    name: 'Pacote PREMIUM ✨',
    coins: 4800,
    price: 'R$ 716,90',
    bonusCoins: 480,
    bonusPercentage: '+10%',
    type: 'premium',
    borderColor: '#fbbf24',
    titleColor: '#d97706',
    pricePrefix: 'Por ',
  },
];

interface PackageCardProps {
  package: PackageOption;
  onSelect: () => void;
}

function PackageCard({ package: pkg, onSelect }: PackageCardProps) {
  const [quantity, setQuantity] = useState(1);

  const handleDecrement = (e: React.MouseEvent) => {
    e.stopPropagation();
    if (quantity > 1) setQuantity(quantity - 1);
  };

  const handleIncrement = (e: React.MouseEvent) => {
    e.stopPropagation();
    setQuantity(quantity + 1);
  };

  const CoinIllustration = () => {
    if (pkg.type === 'basic') return <ThreeCoinsIllustration />;
    if (pkg.type === 'premium') return <PremiumCoinIllustration />;
    return <StackedCoinsIllustration />;
  };

  return (
    <div
      style={{
        backgroundColor: '#ffffff', // bg-white
        position: 'relative',

        border: pkg.borderColor
          ? `2px solid ${pkg.borderColor}`
          : '1px solid #E5E7EB',
        borderRadius: '12px',
        boxShadow: '0 2px 8px rgba(0, 0, 0, 0.08)',
        padding: '16px',
      }}
    >
      {/* Top content */}
      <div
        style={{
          display: 'flex',
          gap: '12px', // gap-3
          alignItems: 'flex-start',
          marginBottom: '12px',
        }}
      >
        {/* Left content */}
        <div style={{ flex: 1, minWidth: 0 }}>
          {/* Package name */}
          <p
            style={{
              fontSize: '14px',
              fontWeight: 600,
              lineHeight: '18px',
              color: pkg.titleColor || '#000000',
              marginBottom: '4px',
              whiteSpace: 'nowrap',
              overflow: 'hidden',
              textOverflow: 'ellipsis',
            }}
          >
            {pkg.name}
          </p>

          {/* Coins amount */}
          <p
            style={{
              fontSize: '20px',
              fontWeight: 600,
              lineHeight: '26px',
              color: pkg.type === 'welcome' ? '#6b34bf' : '#000000',
              marginBottom: '4px',
              whiteSpace: 'nowrap',
            }}
          >
            {pkg.coins} moedas
          </p>

          {/* Bonus info */}
          {pkg.bonusCoins && (
            <div
              style={{
                display: 'flex',
                alignItems: 'center',
                gap: '6px', // gap-1.5
                flexWrap: 'wrap',
                marginBottom: '6px',
              }}
            >
              <span
                style={{
                  fontSize: '13px',
                  fontWeight: 400,
                  lineHeight: '17px',
                  color: '#009646',
                  whiteSpace: 'nowrap',
                }}
              >
                <span style={{ fontWeight: 600 }}>+{pkg.bonusCoins}</span>{' '}
                extras
              </span>
              <div
                style={{
                  backgroundColor: '#00803e',
                  borderRadius: '12px',
                  padding: '2px 6px',
                  fontSize: '11px',
                  fontWeight: 600,
                  lineHeight: '14px',
                  color: 'white',
                }}
              >
                {pkg.bonusPercentage}
              </div>
            </div>
          )}

          {/* Price */}
          <p
            style={{
              fontSize: '15px',
              fontWeight: 600,
              lineHeight: '20px',
              color: pkg.type === 'welcome' ? '#6b34bf' : '#000000',
              whiteSpace: 'nowrap',
            }}
          >
            {pkg.pricePrefix}
            {pkg.price}
          </p>
        </div>

        {/* Right - coin illustration */}
        <CoinIllustration />
      </div>

      {/* Divider */}
      <div
        style={{
          borderTop: '1px solid #E5E7EB',
          paddingTop: '12px',
        }}
      >
        {/* Bottom section - horizontal layout */}
        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            gap: '12px', // gap-3
          }}
        >
          {/* Quantity selector - hidden for welcome package */}
          {pkg.type !== 'welcome' && (
            <div
              style={{
                display: 'flex',
                alignItems: 'center',
                flexShrink: 0,
                border: '1px solid #E5E7EB',
                borderRadius: '8px',
                padding: '2px',
                gap: '8px',
              }}
            >
              <button
                onClick={handleDecrement}
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  width: '32px',
                  height: '32px',
                  backgroundColor: 'white',
                  border: 'none',
                  borderRadius: '6px',
                  cursor: 'pointer',
                }}
                aria-label="Diminuir quantidade"
                type="button"
              >
                <Minus size={14} strokeWidth={2.5} color="#64748B" />
              </button>

              <span
                style={{
                  fontSize: '14px',
                  fontWeight: 600,
                  lineHeight: '18px',
                  color: '#000000',
                  minWidth: '16px',
                  textAlign: 'center',
                }}
              >
                {quantity}
              </span>

              <button
                onClick={handleIncrement}
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  width: '32px',
                  height: '32px',
                  backgroundColor: 'white',
                  border: 'none',
                  borderRadius: '6px',
                  cursor: 'pointer',
                }}
                aria-label="Aumentar quantidade"
                type="button"
              >
                <Plus size={14} strokeWidth={2.5} color="#64748B" />
              </button>
            </div>
          )}

          {/* Buy button */}
          <button
            onClick={onSelect}
            style={{
              flex: 1,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'flex-end',
              gap: '8px',

              backgroundColor: 'white',
              borderRadius: '8px',
              padding: '8px 0',
              minHeight: '36px',
              cursor: 'pointer',
              border: 'none',
            }}
            aria-label={`Comprar ${pkg.name}`}
            type="button"
          >
            <ShoppingCart size={18} strokeWidth={2} color="#0E73E8" />
            <span
              style={{
                fontSize: '15px',
                fontWeight: 600,
                lineHeight: '20px',
                color: '#005bdb',
                whiteSpace: 'nowrap',
              }}
            >
              Comprar
            </span>
          </button>
        </div>
      </div>
    </div>
  );
}

export function CoinPackagesModal({
  isOpen,
  onClose,
  onPurchasePackage,
}: CoinPackagesModalProps) {
  return (
    <AnimatePresence>
      {isOpen && (
        <>
          {/* Backdrop */}
          <motion.div
            style={{
              position: 'fixed',
              top: 0,
              right: 0,
              bottom: 0,
              left: 0, // inset-0
              backgroundColor: '#000000', // bg-black
              zIndex: 50, // z-50
              backdropFilter: 'blur(4px)',
              WebkitBackdropFilter: 'blur(4px)',
            }}
            initial={{ opacity: 0 }}
            animate={{ opacity: 0.5 }}
            exit={{ opacity: 0 }}
            onClick={onClose}
          />

          {/* Modal (container) */}
          <div
            style={{
              position: 'fixed',
              top: 0,
              right: 0,
              bottom: 0,
              left: 0, // inset-0
              zIndex: 50, // z-50
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              padding: '16px', // p-4
            }}
          >
            <motion.div
              style={{
                position: 'relative',
                width: '100%',
                maxWidth: '420px',
                backgroundColor: '#FFFFFF',
                borderRadius: '16px',
                boxShadow: '0 20px 60px rgba(0, 0, 0, 0.3)',
                maxHeight: '90vh',
                display: 'flex',
                flexDirection: 'column',
              }}
              initial={{ opacity: 0, scale: 0.95, y: 20 }}
              animate={{ opacity: 1, scale: 1, y: 0 }}
              exit={{ opacity: 0, scale: 0.95, y: 20 }}
              transition={{
                duration: 0.2,
                ease: [0.25, 0.1, 0.25, 1],
              }}
              onClick={(e) => e.stopPropagation()}
            >
              {/* Header - Compact */}
              <div
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'space-between',
                  flexShrink: 0,
                  padding: '16px 20px 12px 20px',
                }}
              >
                <div
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    gap: '8px',
                  }}
                ></div>

                <motion.button
                  onClick={onClose}
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    flexShrink: 0,
                    width: '44px',
                    height: '44px',
                    color: 'var(--muted-foreground)',
                    border: 'none',
                    backgroundColor: 'transparent',
                    borderRadius: 'var(--radius-button)',
                    cursor: 'pointer',
                  }}
                  whileTap={{ scale: 0.95 }}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.backgroundColor = 'var(--muted)';
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.backgroundColor = 'transparent';
                  }}
                  aria-label="Fechar"
                  type="button"
                >
                  <X style={{ width: '20px', height: '20px' }} />
                </motion.button>
              </div>

              {/* Educational Header */}
              <div
                style={{
                  flexShrink: 0,
                  padding: '0 20px 16px 20px',
                }}
              >
                <h2
                  style={{
                    fontSize: 'var(--text-xl)',
                    fontWeight: 'var(--font-weight-semibold)',
                    color: 'var(--foreground)',
                    lineHeight: '1.4',
                    marginBottom: '8px',
                  }}
                >
                  Para liberar este pedido,
                  <br />
                  adquira moedas primeiro
                </h2>

                <p
                  style={{
                    fontSize: 'var(--text-sm)',
                    fontWeight: 'var(--font-weight-normal)',
                    color: 'var(--muted-foreground)',
                    lineHeight: '1.5',
                  }}
                >
                  Liberando pedidos, você recebe acesso ao contato do cliente.
                  Quanto antes você liberar, maiores as chances de fechar
                  negócio!
                </p>
              </div>

              {/* Divider */}
              <div
                style={{
                  height: '1px',
                  backgroundColor: 'var(--border)',
                  margin: '0 20px 16px 20px',
                }}
              />

              {/* Content - Scrollable list */}
              <div
                style={{
                  overflowY: 'auto',
                  padding: '0 20px 20px 20px',
                  flex: 1,
                }}
              >
                <div
                  style={{
                    display: 'flex',
                    flexDirection: 'column',
                    gap: '12px',
                  }}
                >
                  {packages.map((pkg) => (
                    <PackageCard
                      key={pkg.id}
                      package={pkg}
                      onSelect={() => onPurchasePackage?.()}
                    />
                  ))}
                </div>
              </div>
            </motion.div>
          </div>
        </>
      )}
    </AnimatePresence>
  );
}
